import DefaultElementNodeType from '../DefaultElementNodeType';
import {IMP_MIG_DELIVERABLE} from '../../metamodel/Concept';

export default class DeliverableNodeType extends DefaultElementNodeType {
	static get typeName() {
		return IMP_MIG_DELIVERABLE;
	}
}
